import { useMemo } from 'preact/hooks';
import { makeConfetti, makeEmbers } from '../lib/fx';
import { useController } from '../state/context';

const CONFETTI = 46;
const EMBERS = 22;

/** Победа — салют из конфетти. */
function Confetti() {
  const pieces = useMemo(() => makeConfetti(CONFETTI), []);
  return (
    <div class="fx confetti" aria-hidden="true" data-testid="fx-confetti">
      {pieces.map((p) => (
        <i
          key={`${p.x}-${p.delay}`}
          style={{
            '--x': `${p.x}%`,
            '--w': `${p.w}px`,
            '--dl': `${p.delay}s`,
            '--t': `${p.time}s`,
            '--dx': `${p.dx}px`,
            '--rot': `${p.rot}deg`,
            '--col': p.color,
          }}
        />
      ))}
    </div>
  );
}

/** Поражение — вспышка, две ударные волны и разлетающиеся угольки. */
function Blast() {
  const embers = useMemo(() => makeEmbers(EMBERS), []);
  return (
    <div class="fx blast" aria-hidden="true" data-testid="fx-blast">
      <div class="flash" />
      <div class="ring" />
      <div class="ring two" />
      {embers.map((e) => (
        <i
          class="ember"
          key={`${e.dx}-${e.dy}`}
          style={{
            '--dx': `${e.dx}px`,
            '--dy': `${e.dy}px`,
            '--s': `${e.size}px`,
            '--dl': `${e.delay}s`,
            '--col': e.color,
          }}
        />
      ))}
    </div>
  );
}

/** Эффекты поверх экрана. Проигрываются один раз на партию (key) и не ловят клики. */
export function Effects() {
  const c = useController();
  const game = c.game.value;
  if (!game) return null;
  if (game.status === 'win') return <Confetti key={game.id} />;
  if (game.status === 'lose') return <Blast key={game.id} />;
  return null;
}
